function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent } from "vue";
import { mapActions, mapState, mapWritableState } from "pinia";
//@ts-ignore
import { deepCopy } from "@utils/ObjectUtils";
import { usePlaceType } from "@wkComposables/usePlaceType";
//@ts-ignore
import { usePlaceName } from "@wkComposables/usePlaceName";
//@ts-ignore
import { useSearch } from "@wkComposables/useSearch";
//@ts-ignore
import { PLACE_TYPE } from "@customTypes/PlaceType";
//@ts-ignore
import { getDistrictsByZoneId, getPlace, getZones } from "@services/placesAPI";
//@ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
//@ts-ignore
import { getPlacesAddressAutocomplete } from "@services/geographyAPI";
//@ts-ignore
import { getPlaceFromGAutocomplete } from "@utils/GAutocompleteUtils";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import { DrawIcon } from "@vueEntry/SvgIcons/DrawIcon";
//@ts-ignore
import { PinIcon } from "@vueEntry/SvgIcons/PinIcon";
//@ts-ignore
import { SearchIcon } from "@vueEntry/SvgIcons/SearchIcon";
//@ts-ignore
import StaticSpinner from "@vueEntry/StaticSpinner.vue";
//@ts-ignore
import CheckboxBtn from "@vueEntry/UIKitComponents/Checkbox/CheckboxBtn.vue";
import RadioButton from "@vueEntry/UIKitComponents/Radio/RadioButton.vue";
import { useSearchBeanStore } from "@store/SearchBeanStore";
import { useHomeTabStore } from "@wkWebSrc/js/store";
import { TABTYPE as _TABTYPE } from "@customTypes/HomeTabTypeEnum";
import { useValuationPlaceStore } from "@store/ValuationPlaceStore";
import BaseAccordionItem from "@vueEntry/UIKitComponents/Accordion/BaseAccordionItem.vue";
export default defineComponent({
  name: "PlaceBox",
  components: {
    StaticSpinner: StaticSpinner,
    RadioButton: RadioButton,
    BaseInput: BaseInput,
    BaseAutocomplete: BaseAutocomplete,
    BaseButton: BaseButton,
    CheckboxBtn: CheckboxBtn,
    DrawIcon: DrawIcon,
    PinIcon: PinIcon,
    SearchIcon: SearchIcon,
    BaseAccordionItem: BaseAccordionItem
  },
  props: {
    customListingTypologyURL: {
      type: String,
      "default": ""
    },
    useContractType: {
      type: Boolean,
      "default": true
    },
    agencyFilter: {
      type: Object,
      "default": null
    },
    hasError: {
      type: Boolean
    },
    listing: {
      type: Boolean
    },
    freesearch: {
      type: Boolean
    },
    freesearchDefault: {
      type: String
    },
    place: {
      type: Object
    },
    showPlaceMapDropDown: {
      type: Boolean,
      "default": true
    },
    dropDownMenuActive: {
      type: Boolean,
      "default": false
    },
    closeDropDown: {
      type: Boolean,
      "default": false
    },
    isAgency: {
      type: Boolean
    }
  },
  emits: ["focus-in", "hide-place-modal", "show-map", "new-place", "emit-place"],
  setup: function setup() {
    var _usePlaceType = usePlaceType(),
      localityList = _usePlaceType.localityList,
      zoneList = _usePlaceType.zoneList,
      searchBeanModal = _usePlaceType.searchBeanModal,
      localitySelected = _usePlaceType.localitySelected,
      zoneIDsSelected = _usePlaceType.zoneIDsSelected,
      zoneModifiedByUser = _usePlaceType.zoneModifiedByUser,
      districtSelected = _usePlaceType.districtSelected,
      districtsObj = _usePlaceType.districtsObj,
      convertEnergyClassFilter = _usePlaceType.convertEnergyClassFilter,
      convertFloor = _usePlaceType.convertFloor,
      resetSearchBeanZonesAndLocalities = _usePlaceType.resetSearchBeanZonesAndLocalities,
      updateSearchModal = _usePlaceType.updateSearchModal,
      updateSearchModalAndPlace = _usePlaceType.updateSearchModalAndPlace,
      fixSearchBean = _usePlaceType.fixSearchBean,
      initZonesAndLocalities = _usePlaceType.initZonesAndLocalities,
      areAllDistrictsSelected = _usePlaceType.areAllDistrictsSelected,
      isZoneOrLocalitySelected = _usePlaceType.isZoneOrLocalitySelected,
      areZonesAndLocalitiesEmpty = _usePlaceType.areZonesAndLocalitiesEmpty,
      areZonesAndLocalitiesFilled = _usePlaceType.areZonesAndLocalitiesFilled,
      getSingleSelectedDistrict = _usePlaceType.getSingleSelectedDistrict,
      getZoneById = _usePlaceType.getZoneById,
      resetZoneAndLocalities = _usePlaceType.resetZoneAndLocalities,
      isZoneSelected = _usePlaceType.isZoneSelected,
      isLocationSelected = _usePlaceType.isLocationSelected,
      isDistrictSelected = _usePlaceType.isDistrictSelected,
      insertDistrictByZoneId = _usePlaceType.insertDistrictByZoneId,
      onPlaceLIClick = _usePlaceType.onPlaceLIClick,
      onDistrictClick = _usePlaceType.onDistrictClick;
    var _usePlaceName = usePlaceName(),
      currentPlaceName = _usePlaceName.currentPlaceName,
      locationLabel = _usePlaceName.locationLabel,
      zonesLabel = _usePlaceName.zonesLabel,
      updateLocationName = _usePlaceName.updateLocationName,
      updateZoneName = _usePlaceName.updateZoneName,
      updateSingleDistrictName = _usePlaceName.updateSingleDistrictName,
      updateGenericPlaceName = _usePlaceName.updateGenericPlaceName,
      updateCityName = _usePlaceName.updateCityName;
    var _useSearch = useSearch(),
      search = _useSearch.search;
    return {
      //Refs
      currentPlaceName: currentPlaceName,
      //Computed
      locationLabel: locationLabel,
      zonesLabel: zonesLabel,
      //Methods
      updateLocationName: updateLocationName,
      updateZoneName: updateZoneName,
      updateSingleDistrictName: updateSingleDistrictName,
      updateGenericPlaceName: updateGenericPlaceName,
      updateCityName: updateCityName,
      //usePlaceType
      localityList: localityList,
      zoneList: zoneList,
      searchBeanModal: searchBeanModal,
      localitySelected: localitySelected,
      zoneIDsSelected: zoneIDsSelected,
      zoneModifiedByUser: zoneModifiedByUser,
      districtSelected: districtSelected,
      districtsObj: districtsObj,
      //Methods
      convertEnergyClassFilter: convertEnergyClassFilter,
      convertFloor: convertFloor,
      resetSearchBeanZonesAndLocalities: resetSearchBeanZonesAndLocalities,
      updateSearchModal: updateSearchModal,
      updateSearchModalAndPlace: updateSearchModalAndPlace,
      fixSearchBean: fixSearchBean,
      initZonesAndLocalities: initZonesAndLocalities,
      areAllDistrictsSelected: areAllDistrictsSelected,
      isZoneOrLocalitySelected: isZoneOrLocalitySelected,
      areZonesAndLocalitiesEmpty: areZonesAndLocalitiesEmpty,
      areZonesAndLocalitiesFilled: areZonesAndLocalitiesFilled,
      getSingleSelectedDistrict: getSingleSelectedDistrict,
      getZoneById: getZoneById,
      resetZoneAndLocalities: resetZoneAndLocalities,
      isZoneSelected: isZoneSelected,
      isLocationSelected: isLocationSelected,
      isDistrictSelected: isDistrictSelected,
      insertDistrictByZoneId: insertDistrictByZoneId,
      onPlaceLIClick: onPlaceLIClick,
      onDistrictClick: onDistrictClick,
      //useSearch
      search: search
    };
  },
  data: function data() {
    return {
      disableCb: true,
      valuationAddress: undefined,
      autocompleteValue: undefined,
      freesearchValue: "",
      placeTest: null,
      showMapModal: false,
      mapPlace: null,
      aroundMe: false,
      showZoneModal: false,
      tempPlace: null,
      publicValuation: {
        realEstateValuation: {
          address: "",
          sqM: null,
          rooms: null,
          typologyID: 0
        },
        privateValuation: true,
        contactDesired: null,
        email: "",
        name: "",
        surname: "",
        phone: null
      },
      dropDownMenu: false,
      spinnerIcon: false,
      isSelectionValid: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign({
    TABTYPE: function TABTYPE() {
      return _TABTYPE;
    },
    placeholder: function placeholder() {
      return this.isAgency ? "Inserisci luogo" : this.labels.insertSearchCity;
    },
    labels: function labels() {
      return window["_labels"];
    },
    containerClasses: function containerClasses() {
      if (!this.listing || this.freesearch) return "";
      return this.showZoneModal || this.dropDownMenu ? "" : "";
    },
    isSearchReady: function isSearchReady() {
      return !(!this.searchBean.cityURL && !this.searchBean.polygonFromMap);
    },
    localitiesLabel: function localitiesLabel() {
      return this.labels.localities;
    },
    cdn: function cdn() {
      return window["_cdn"];
    },
    hasValuationAddress: function hasValuationAddress() {
      var _a;
      return !!((_a = this.tempPlace) === null || _a === void 0 ? void 0 : _a.address);
    },
    openDropdownMenu: function openDropdownMenu() {
      var _a;
      return !((_a = this.autocompleteValue) === null || _a === void 0 ? void 0 : _a.label) || this.isSelectionValid && !this.showZoneModal;
    }
  }, mapState(useSearchBeanStore, ["searchBean"])), mapState(useHomeTabStore, ["activeTab"])), mapState(useHomeTabStore, {
    valuation: function valuation(store) {
      return store.isTabActive(_TABTYPE.VALUATE);
    },
    selling: function selling(store) {
      return store.isTabActive(_TABTYPE.SELLING);
    },
    isTrendPage: function isTrendPage(store) {
      return store.isTabActive(_TABTYPE.TREND);
    }
  })), mapWritableState(useValuationPlaceStore, ["valuationAddressLoading", "valuationPlace"])),
  watch: {
    showZoneModal: function showZoneModal(cur, prev) {
      this.disableCb = cur;
    },
    currentPlaceName: function currentPlaceName(cur, prev) {
      this.autocompleteValue = {
        label: cur
      };
      this.isSelectionValid = true;
    },
    searchBean: {
      handler: function handler(cur, prev) {
        if (cur.polygonFromMap) {
          this.zoneList = [];
          this.zoneIDsSelected = [];
          this.localityList = [];
          this.localitySelected = undefined;
          this.showZoneModal = false;
          this.zoneModifiedByUser = false;
          this.districtsObj = {};
          this.districtSelected = {};
        }
        if (!this.searchBean.polygonFromMap && !this.searchBean.cityDisplayName && !this.searchBean.cityURL && !this.searchBean.cityName) this.currentPlaceName = "";
        //this is because mapModal emit the place to the searchboxhome and the only way to know that the placename need to be update is to watch it
        else if (this.searchBean.polygonFromMap) this.updatePlaceName();
        // else
        //     this.updatePlaceName();
      },
      deep: true
    },
    closeDropDown: {
      handler: function handler(cur, prev) {
        this.dropDownMenu = !cur;
        this.showZoneModal = !cur;
      }
    }
  },
  created: function created() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this = this;
      var _this$searchBeanModal, zoneIdList, localityIdList, cityId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.updateSearchModal(JSON.parse(JSON.stringify(this.searchBean)));
            this.convertEnergyClassFilter();
            this.convertFloor();
            this.freesearchValue = (_a = this.freesearchDefault) !== null && _a !== void 0 ? _a : "";
            this.dropDownMenu = this.dropDownMenuActive;
            //This listener will be used to close the zone modal whenever the user click outside the zones/localities dropdown
            document.body.addEventListener("click", function (event) {
              var clickedItem = event.target;
              if (_this.showZoneModal) {
                _this.showZoneModal = false;
              }
              if (_this.dropDownMenu && !clickedItem.className.includes("exclude-event-target")) {
                _this.dropDownMenu = false;
              }
            });
            if (this.place) this.placeTest = deepCopy(this.place);
            _this$searchBeanModal = this.searchBeanModal, zoneIdList = _this$searchBeanModal.zoneIdList, localityIdList = _this$searchBeanModal.localityIdList, cityId = _this$searchBeanModal.cityId; //Just one zone
            if (((_b = this.placeTest) === null || _b === void 0 ? void 0 : _b.zoneID) && !this.placeTest.districtID) this.zoneIDsSelected = [this.placeTest.zoneID];else if (zoneIdList && zoneIdList.length > 0 && ((_c = this.placeTest) === null || _c === void 0 ? void 0 : _c.placeType) !== "D") {
              this.zoneIDsSelected = zoneIdList;
            } else if (((_d = this.placeTest) === null || _d === void 0 ? void 0 : _d.placeType) === PLACE_TYPE.DISTRICT) {
              this.searchBeanModal.zoneId = null;
              this.searchBeanModal.zoneIdList = [];
              this.zoneIDsSelected = [];
            }
            if (!cityId) {
              _context.next = 15;
              break;
            }
            _context.next = 12;
            return this.initZonesAndLocalities(getZones(cityId));
          case 12:
            if (localityIdList) {
              _context.next = 14;
              break;
            }
            return _context.abrupt("return");
          case 14:
            this.localitySelected = this.localityList.find(function (l) {
              return l.localityID === localityIdList[0];
            });
          case 15:
            this.updatePlaceName();
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
  },
  methods: Object.assign({
    initSingleDistrict: function initSingleDistrict(zoneId, districtId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var districts, singleDistrict;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getDistrictsByZoneId(zoneId);
            case 2:
              districts = _context2.sent;
              singleDistrict = districts.find(function (d) {
                return d.districtID === districtId;
              });
              this.districtsObj[singleDistrict === null || singleDistrict === void 0 ? void 0 : singleDistrict.zoneID] = [singleDistrict];
              //Adding the district to the district object
              this.insertDistrictByZoneId(zoneId, districtId);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    },
    onInputChangeCb: function onInputChangeCb(query) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (query) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _context3.next = 4;
              return getPlacesAddressAutocomplete(query, 10);
            case 4:
              res = _context3.sent;
              return _context3.abrupt("return", res.map(function (r) {
                return {
                  label: r.description,
                  id: r.place_id
                };
              }));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
    },
    optionSelectedCb: function optionSelectedCb(selectedEl) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _yield$getPlaceFromGA, place;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.disableCb = true;
              this.valuationAddressLoading = true;
              _context4.next = 4;
              return getPlaceFromGAutocomplete("".concat(selectedEl.id), selectedEl.label);
            case 4:
              _yield$getPlaceFromGA = _context4.sent;
              place = _yield$getPlaceFromGA.place;
              this.valuationAddressLoading = false;
              this.tempPlace = place;
              this.confirmPlace();
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    },
    handleClick: function handleClick() {
      this.$refs.placeAutocomplete.select();
      this.disableCb = false;
      /* We won't show the dropdown to open the map in valuation or selling mode */
      if (this.valuation || this.selling) return;
      /* Showing the dropdown when there is no text in place autocomplete */
      if (this.openDropdownMenu) this.dropDownMenu = true;
    },
    managePlace: function managePlace(selectedPlace) {
      var _this2 = this;
      if (!selectedPlace) return;
      this.disableCb = true;
      this.resetSearchBeanZonesAndLocalities();
      var updatePlaceCb = function updatePlaceCb() {
        _this2.placeTest = Object.assign({}, selectedPlace);
        _this2.confirmPlace();
      };
      if (selectedPlace.placeType == PLACE_TYPE.CITY) {
        this.updateSearchModalAndPlace(selectedPlace, function () {
          _this2.placeTest = Object.assign({}, selectedPlace);
        });
        if (!this.isTrendPage) {
          this.emitPlace();
          this.updatePlaceName();
          this.initZonesAndLocalities(getZones(selectedPlace.cityID), function () {
            _this2.openZoneModal();
          },
          //that means there are no zones
          function () {
            _this2.updateSearchModalAndPlace(selectedPlace, updatePlaceCb);
          });
        } else {
          this.confirmPlace();
          this.updatePlaceName();
        }
      } else if (selectedPlace.placeType == PLACE_TYPE.DISTRICT) {
        this.initSingleDistrict(selectedPlace.zoneID, selectedPlace.districtID).then(function () {
          _this2.updateSearchModalAndPlace(selectedPlace, updatePlaceCb);
        });
      } else if (selectedPlace.placeType == PLACE_TYPE.ZONE) {
        this.updateZoneName(selectedPlace, 1);
        this.updateSearchModalAndPlace(selectedPlace, updatePlaceCb);
      } else
        //e.g. if the selected
        //option is a province...
        this.updateSearchModalAndPlace(selectedPlace, updatePlaceCb);
    },
    openDropDown: function openDropDown(e) {
      e.stopPropagation();
      this.dropDownMenu = true;
    },
    fromDropDownToZoneModal: function fromDropDownToZoneModal() {
      this.dropDownMenu = false;
      if (this.isTrendPage) this.confirmPlace();
      var hasAnyZonesOrLocalities = this.zoneList.length + this.localityList.length;
      if (hasAnyZonesOrLocalities) this.showZoneModal = true;
    },
    updatePlaceNameAndEmit: function updatePlaceNameAndEmit() {
      this.updatePlaceName();
      this.emitPlace();
    },
    updatePlaceName: function updatePlaceName() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      /* LOCALITY */
      if (this.localitySelected || ((_a = this.placeTest) === null || _a === void 0 ? void 0 : _a.localityID) && !this.zoneIDsSelected.length) {
        this.updateLocationName((_b = this.localitySelected) !== null && _b !== void 0 ? _b : this.placeTest);
        return;
      }
      /* DRAWN AREA MAP */
      // eslint-disable-next-line max-len
      if (this.listing && !!this.searchBeanModal.polygonFromMap && this.searchBeanModal.placeType != "I" || !this.listing && !!this.searchBean.polygonFromMap && this.searchBean.placeType != "I") {
        this.currentPlaceName = this.labels.mapAreaDrawn;
      }
      /* VACATION PLACE LIKE CINQUE TERRE */else if (!!this.searchBean.polygonFromMap && this.searchBean.placeType == "I") {
        this.currentPlaceName = (_c = this.searchBean) === null || _c === void 0 ? void 0 : _c.cityDisplayName;
      } else if (this.searchBeanModal.placeType == PLACE_TYPE.AREA) {
        this.updateGenericPlaceName(this.placeTest);
      } else {
        //Zones and district greater than one => IFF they are selected
        if (this.zoneIDsSelected.length >= 0 || ((_d = this.searchBeanModal.districtIdList) === null || _d === void 0 ? void 0 : _d.length) >= 0) {
          if ([PLACE_TYPE.PROVINCE, PLACE_TYPE.AREA_OF_INTEREST, PLACE_TYPE.REGION, PLACE_TYPE.LOCALITY].includes(((_e = this.placeTest) === null || _e === void 0 ? void 0 : _e.placeType) || "")) this.updateGenericPlaceName(this.placeTest);
          // eslint-disable-next-line max-len
          else if (!((_f = this.searchBeanModal.districtIdList) === null || _f === void 0 ? void 0 : _f.length) && !this.searchBeanModal.districtId && !this.zoneIDsSelected.length && !this.searchBeanModal.zoneId) this.updateCityName(this.placeTest);else if (!this.zoneIDsSelected.length && ((_g = this.searchBeanModal.districtIdList) === null || _g === void 0 ? void 0 : _g.length) === 1) this.updateSingleDistrictName(this.getSingleSelectedDistrict());else if (this.zoneIDsSelected.length === 1 && !((_h = this.searchBeanModal.districtIdList) === null || _h === void 0 ? void 0 : _h.length)) this.updateZoneName(this.getZoneById(this.zoneIDsSelected[0]), 1);else this.updateZoneName(this.placeTest, this.zoneIDsSelected.length + ((_j = this.searchBeanModal.districtIdList) === null || _j === void 0 ? void 0 : _j.length));
        }
      }
    },
    openZoneModal: function openZoneModal() {
      if (this.zoneList.length + this.localityList.length && (!this.valuation || !this.selling)) this.showZoneModal = true;
    },
    getPlaceFn: function getPlaceFn(query) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (query) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              //By default, any input modification will be considered not valid until the selection
              this.isSelectionValid = false;
              this.autocompleteValue = {
                label: query
              };
              this.resetZoneAndLocalities();
              _context5.next = 7;
              return getPlace(query, "C,P,Z,L,I,R,A,D");
            case 7:
              res = _context5.sent;
              return _context5.abrupt("return", res.map(function (place, index) {
                return {
                  id: index,
                  label: place.displayName,
                  payload: place
                };
              }));
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    },
    confirmPlace: function confirmPlace() {
      var _this3 = this;
      var _a;
      this.spinnerIcon = true;
      this.updatePlaceName();
      if (this.freesearch) {
        this.search(this.listing, this.customListingTypologyURL, this.useContractType, this.agencyFilter, {
          value: this.freesearchValue
        });
      } else if (this.valuation || this.selling) {
        this.publicValuation.realEstateValuation.address = ((_a = this.tempPlace) === null || _a === void 0 ? void 0 : _a.address) || "";
        this.placeTest = this.tempPlace;
        this.tempPlace = null;
        this.emitPlace();
      } else {
        this.fixSearchBean(function () {
          var _a;
          _this3.placeTest = _this3.zoneList.find(function (plc) {
            return plc.zoneID == _this3.searchBeanModal.zoneId;
          }) || _this3.placeTest;
          return (_a = _this3.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        }, function () {
          var _a;
          _this3.placeTest = _this3.localitySelected ? Object.assign({}, _this3.localitySelected) : _this3.placeTest;
          return (_a = _this3.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        }, function () {
          var _a;
          return (_a = _this3.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        });
        this.updatePlaceName();
        this.searchBeanModal.polygonFromMap = "";
        this.searchBeanModal.polygonForDB = undefined;
        if (this.listing) {
          this.updateSearchBean(this.searchBeanModal);
          this.search(this.listing, this.customListingTypologyURL, this.useContractType, this.agencyFilter);
        } else {
          this.emitPlace();
          this.dropDownMenu = false;
        }
      }
    },
    openMapDraw: function openMapDraw() {
      if (this.listing) this.hidePlaceModal();
      this.showMap();
    },
    closeModal: function closeModal() {
      var _a, _b;
      document.body.classList.remove("modal-open");
      (_a = this.backdrop) === null || _a === void 0 ? void 0 : _a.classList.remove("show", "tw-block");
      (_b = this.backdrop) === null || _b === void 0 ? void 0 : _b.classList.add("tw-hidden");
    },
    hidePlaceModal: function hidePlaceModal() {
      this.closeModal();
      this.$emit("hide-place-modal", true);
    },
    showMap: function showMap() {
      this.$emit("show-map", {
        aroundMe: this.aroundMe,
        searchBean: this.searchBeanModal
      });
    },
    emitPlace: function emitPlace() {
      var _this4 = this;
      /* closes keyboard after sending the place on safari */
      this.updatePlaceName();
      if (this.valuation || this.selling) {
        this.valuationPlace = this.placeTest;
      } else {
        //Ensuring that the place and the searchBeanModal have updated before emitting them
        this.$nextTick(function () {
          _this4.$emit("emit-place", {
            place: _this4.placeTest,
            aroundMe: false,
            radius: 0,
            searchBean: deepCopy(_this4.searchBeanModal),
            polygon: ""
          });
        });
      }
    }
  }, mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean"]))
});